<template>
  <div>
    <div class="absolute top-0 sm:ml-0 flex items-center lg:items-baseline pt-4 lg:ml-16 sm:pt-14 md:px-6 z-50 w-full justify-between lg:justify-start">
      <a :href="url" >
        <img
          src="@/assets/img/logo/goparity.svg"
          alt=""
          class="w-28 sm:w-40 ml-4 sm:ml-0"
        />
      </a>
    </div>
    <swiper
      :effect="'fade'"
      :fadeEffect="{ crossFade: true }"
      :autoplay="{
        delay: 3500,
        disableOnInteraction: true,
      }"
      :grabCursor="true"
      :loop="true"
      :modules="modules"
      :pagination="{
        clickable: true,
      }"
      :slides-per-view="1"
      :space-between="50"
      @swiper="setSwiper"
      class="swiper-container">
      <swiper-slide
        v-for="el in data"
        v-bind:key="el.title"
        class="p-6"
      >
        <div
          class="text-3xl mb-4 no-highlight font-bold text-blue-ocean-1"
          v-html="el.title"
        />
        <div
          class="text-sm font-medium no-highlight text-grey-3 z-40"
          v-html="el.subtitle"
        />
        <img 
          :src="dir + el.img" 
          alt="Goparity explanation" 
          class="w-4/5 sm:w-auto absolute max-w-full bottom-0 right-0 sm:right-auto sm:left-0 lg:left-1/2 max-h-full lg:-translate-x-1/2 transform z-negative" />
      </swiper-slide>
    </swiper>
    <GpButton
      id="gp-button-go-to-signup-1"
      :mobileWidth="'w-4/5'"
      class="my-2 text-13 mx-auto"
      @click="revealSignup()"
    >
      {{ $t('signup.go_to_signup_w_voucher', {campaign_value: campaignValue}) }}
    </GpButton>
  </div>
</template>

<script>
  import { ref, computed } from 'vue'
  import { Swiper, SwiperSlide } from 'swiper/vue'
  import GpButton from '@/components/general/GpButton.vue'
  import SwiperCore, { EffectFade, Pagination, Autoplay} from 'swiper'

  SwiperCore.use([Pagination, EffectFade, Autoplay])

  export default {
    components: {
      GpButton,
      Swiper,
      SwiperSlide,
    },
    props: {
      campaignValue: {
        type: String,
        default: '5'
      },
      data: {
        type: Object,
        default: null
      },
      dir: {
        type: String,
        default: null
      }
    },
    setup(props, { emit }) {
      let swiper = ref(null)

      function setSwiper(swiper) {
        swiper.value = swiper
      }

      const url = computed(() => {
        return process.env.VUE_APP_FE_PP_BASE_URL
      })

      const revealSignup = () => {
        emit('revealSignup')
      }
      
      return {
        modules: [Pagination, EffectFade, Autoplay],
        revealSignup,
        setSwiper,
        swiper,
        url
      };
    },
  };
</script>

<style scoped>
.swiper-wrapper {
  height: 90svh;
}

.swiper-container {
  height: 90svh;
  padding-top: 4rem;
}

@media (min-width: 820px) {
  .swiper-container {
    padding-top: 6rem;
  }
}

:deep(.swiper-pagination-bullets) {
  display: flex;
  justify-content: center;
  gap: 5px;
}

:deep(.swiper-pagination-bullets) {
  top: 60px;
  bottom: unset !important;
}

@media (min-width: 820px) {
  :deep(.swiper-pagination-bullets) {
    top: 100px;
    bottom: unset !important;
  }
}

:deep(.swiper-pagination-bullet) {
  width: 60px; 
  height: 2px;  
  background-color: #d3d3d3; /* Default color */
  border-radius: 2px;
  transition: background-color 0.3s ease; /* Smooth transition for active state */
}

:deep(.swiper-pagination-bullet-active) {
  background-color: #0D3B50; 
}
</style>
